import React from "react";
import { useTranslation } from "react-i18next";

import { cls } from "app/utils";

import styles from "./styles.module.scss";
import ButtonVariant from "app/components/Button/ButtonVariant";

type PropsDef = {
  onSubmit: () => void;
  onCancel: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  submitDisabled?: boolean;
  style?: string;
  showCancel?: boolean;
  showSubmit?: boolean;
};

export default function SaveBar(props: PropsDef) {
  const { t } = useTranslation();
  const {
    onSubmit,
    onCancel,
    style,
    submitLabel = t("Next"),
    cancelLabel = t("Cancel"),
    submitDisabled = false,
    showCancel,
    showSubmit = true,
  } = props;

  if (!showCancel && !showSubmit) {
    return null;
  }
  return (
    <div className={cls(styles.save_bar, style)}>
      {showCancel ? (
        <ButtonVariant
          title={cancelLabel}
          buttonType='secondary-outline'
          onClickFunc={onCancel}
        />
      ) : null}
      {showSubmit ? <ButtonVariant
        title={submitLabel}
        buttonType='primary'
        onClickFunc={onSubmit}
        disabled={submitDisabled}
        data-testid="sessions-save-button"
      /> : null}
    </div>
  );
}
